import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9dg68q5ze: FaireProductEntity = {
  token: "p_e9dg68q5ze",
  type: "product",
  name: "Golden Hour - 14oz. Candle",
  brandToken: "b_w4s2ssyjfg",
  brandName: "Hico Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/44ef77bff781b608655151806b5423fb41a69640fa23ee91fa19686afbe85669.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f6b202a0ea5dd5e058673f3e8eb6f98e288ac458a5653295bd55347b062932a.jpeg",
    "https://cdn.faire.com/fastly/38b9702fcc22f09e8b75ff110d7d84513e315e17b4b700f4bd2dabb0f30da851.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Introducing Golden Hour, a scent that embodies the essence of sublime harmony and captivating complexity. This fragrance commences its enchanting narrative with the bold yet seductive aroma of passion fruit. Its tart sweetness, a vibrant homage to exotic gardens, instantly engages the senses, painting a picture of tropical escapes and sunlit afternoons. This lively opening note seamlessly dances into the effervescent charm of sparkling tea, its light and rejuvenating scent adding a layer of elegance and tranquility, reminiscent of serene afternoons. The journey culminates in the warm, earthy embrace of patchouli. Its depth and mystique provide a perfect counterbalance, grounding the sweetness and lightness of the preceding notes. Golden Hour is an olfactory symphony, a unique blend that transcends the ordinary.\n\nOur 14oz. candles are hand poured using a blended soy wax and double cotton wick.",
  tags: [],
  msrpDollars: 35,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:09.310Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
